<template lang="pug">
div
  el-card(shadow="hover")
    app-divider(label="Observações: ", :addMarginTop="false").margin-bottom
    el-row.margin-left
      el-row.margin-bottom15
        span - Alienação de imóveis estaduais de acordo com a Lei nº 110/2018;
      el-row.margin-bottom15
        span - Os valores definidos na Pauta de Valores de Terra Nua para fins de Titulação expressam o custo médio da terra rural obtida pelo Incra;
      el-row.margin-bottom15
        span - Em áreas até 15 MF mediante aprovação do órgão fundiário oficial do Estado e acima de 15 MF até 2.500 ha mediante aprovação do órgão fundiário oficial do Estado e
          | com prévia aprovação da Comissão Permanente de Política Agrária da Assembleia Legislativa.
      el-row.margin-bottom15
        span - Fórmula de Cálculo:
          el-row.margin-left
            b.color CÁLCULO DO PERCENTUAL DE BÔNUS
          el-row.margin-left
            span (Coeficiente Angular &nbsp x &nbsp Área requerida) &nbsp + &nbsp Coeficiente Linear &nbsp = &nbsp Percentual a ser aplicado sobre o VTN
          el-row.margin-left
            b.color CÁLCULO DE VFI
          el-row.margin-left
              span ((Percentual a ser aplicado sobre o VTN &nbsp / &nbsp 100 &nbsp ) &nbsp x &nbsp Valor mínimo da Pauta de VTN) &nbsp x &nbsp Área Requerida &nbsp = &nbsp Valor Final do Imóvel
</template>

<script>
import AppDivider from '@/components/AppDivider.vue'
export default {
  components: {
    AppDivider
  }
}
</script>

<style lang="scss" scoped>
.margin-bottom {
  margin-bottom: 20px;
}

.margin-bottom15 {
  margin-bottom: 15px;
}

.margin-left {
  margin-left: 10px;
  margin-top: 10px;
}

.color {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/components/Observacoes.vue